import cx from 'classnames';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

import color from 'core/libs/color';

import withTheme from 'core/hocs/withTheme';

import styles from './heightSetter.styl';

const blankHeight = 0;


function HeightSetter({ children, updateHeightKey, heightValue, wrapperRef, collapsedHeight, theme }) {
  const [opened, setOpened] = useState(false);
  const [toggled, setToggled] = useState(false);

  useEffect(() => {
    if (toggled) {
      setOpened(true);
    } else if (heightValue) {
      setOpened(heightValue < collapsedHeight);
    }
  }, [collapsedHeight, heightValue, updateHeightKey, toggled]);

  const transparentLayout = color(theme.colors.layout).alpha(0).string();
  const hideCaption = !children;

  return (
    <div
      className={cx(
        styles.heightSetter,
        opened && styles._isOpened,
        !opened && 'closedHeightSetter', // используется как глобальный селектор CSS
        hideCaption && styles._isBlank,
      )}
      {...!toggled && !opened && { onClick: () => setToggled(true) }}
    >
      <style jsx>{`
        .${styles.heightSetter}
          height ${Math.min(collapsedHeight, heightValue)}px
          @media (prefers-reduced-motion: no-preference)
            transition height ${theme.animations.hover}

          &.${styles._isOpened}
            height ${heightValue}px
            background ${transparentLayout}

          &.${styles._isBlank}
            height ${blankHeight}px
      `}</style>
      <div ref={wrapperRef}>{children}</div>
    </div>
  );
}

HeightSetter.propTypes = {
  heightValue: PropTypes.number,
  updateHeightKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  wrapperRef: PropTypes.object,
  collapsedHeight: PropTypes.number,
  theme: PropTypes.object,
};

export default withTheme(HeightSetter);
